(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDashboardPanel', function () {
            return {
                templateUrl: 'app/dashboard/dashboard-panel.tmpl.html',
                scope: {},
                controller: ['$location', function ($location) {
                    var drvCtrl = this;
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    dashboardSetting: '='
                }
            };
        });
})();